import YFormSaleTaxRule from './SaleTaxRule';

export { YFormSaleTaxRule };
export default YFormSaleTaxRule;
